import React, { useEffect, useState, createElement } from 'react';
import { CheckCircleIcon, FileTextIcon, ClipboardListIcon, ShieldCheckIcon, ClockIcon } from 'lucide-react';
export function App() {
  const [selectedPrice, setSelectedPrice] = useState<'regular' | 'discounted'>('discounted');
  const [showPurchasePopup, setShowPurchasePopup] = useState(false);
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    // Meta Pixel tracking
    if (typeof window !== 'undefined') {
      ;
      (window as any).fbq?.('track', 'PageView');
    }
    // Purchase popup timer
    const showPopup = () => {
      setShowPurchasePopup(true);
      setTimeout(() => setShowPurchasePopup(false), 5000);
    };
    const interval = setInterval(showPopup, Math.random() * 20000 + 40000);
    return () => clearInterval(interval);
  }, []);
  // 24h countdown - persisted in localStorage
  useEffect(() => {
    const STORAGE_KEY = 'kit_offer_end';
    let endTime = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);
    const now = Date.now();
    if (!endTime || endTime < now) {
      endTime = now + 24 * 60 * 60 * 1000;
      localStorage.setItem(STORAGE_KEY, String(endTime));
    }
    const tick = () => {
      const diff = Math.max(0, endTime - Date.now());
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor(diff / (1000 * 60) % 60);
      const seconds = Math.floor(diff / 1000 % 60);
      setTimeLeft({
        hours,
        minutes,
        seconds
      });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);
  const handlePurchase = () => {
    if (selectedPrice === 'discounted') {
      window.location.href = 'https://checkout.sectordigital.online/cart/44132885889067:1';
    }
  };
  const scrollToPricing = () => {
    document.getElementById('pricing-section')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  const argentinianNames = [{
    name: 'María González',
    city: 'Buenos Aires'
  }, {
    name: 'Juan Pérez',
    city: 'Córdoba'
  }, {
    name: 'Laura Martínez',
    city: 'Rosario'
  }, {
    name: 'Carlos Rodríguez',
    city: 'Mendoza'
  }, {
    name: 'Ana López',
    city: 'La Plata'
  }];
  const [currentBuyer] = useState(argentinianNames[Math.floor(Math.random() * argentinianNames.length)]);
  return <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white" data-id="element-0">
      {/* Meta Pixel Script */}
      <script dangerouslySetInnerHTML={{
      __html: `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '26257470350562748');
          `
    }} data-id="element-1" />

      {/* Purchase Notification Popup */}
      {showPurchasePopup && <div className="fixed top-4 left-4 right-4 md:left-auto md:right-4 md:w-80 bg-white border-l-4 border-green-500 shadow-xl rounded-lg p-4 z-50 animate-slide-in" data-id="element-2">
          <div className="flex items-start gap-3" data-id="element-3">
            <CheckCircleIcon className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-4" />
            <div className="flex-1" data-id="element-5">
              <p className="font-bold text-xs text-green-700 uppercase tracking-wide mb-1" data-id="element-6">
                ✓ Compra Verificada
              </p>
              <p className="font-semibold text-sm text-gray-900" data-id="element-7">
                {currentBuyer.name}
              </p>
              <p className="text-xs text-gray-600" data-id="element-8">
                {currentBuyer.city}, Argentina
              </p>
              <p className="text-xs text-gray-500 mt-1" data-id="element-9">
                Acaba de comprar el KIT
              </p>
            </div>
          </div>
        </div>}

      {/* Hero Section - full viewport on mobile, distinct background */}
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-teal-800 via-teal-700 to-emerald-900 px-4 py-6" data-id="element-10">
        <div className="max-w-4xl mx-auto text-center w-full" data-id="element-11">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-white mb-4 leading-tight" data-id="element-12">
            ESTRUCTURÁ TU ACOMPAÑAMIENTO TERAPÉUTICO CON UN SISTEMA COMPROBADO
          </h1>
          <p className="text-lg md:text-2xl font-semibold text-amber-300 mb-4" data-id="element-13">
            KIT Acompañante Terapéutico
          </p>

          {/* Product Image - placed under KIT title */}
          <div className="mb-4" data-id="element-14">
            <img src="https://cdn.magicpatterns.com/uploads/o7JmaXCjSfdKSmmPoViSvU/Diseno_sin_titulo_(29).png" alt="KIT Acompañante Terapéutico" onClick={scrollToPricing} className="w-full mx-auto cursor-pointer hover:opacity-90 transition-opacity drop-shadow-2xl" style={{
            maxWidth: '240px'
          }} loading="eager" data-id="element-15" />
          </div>

          <p className="text-sm md:text-base text-teal-50 mb-5 max-w-2xl mx-auto leading-relaxed" data-id="element-16">
            El sistema completo para acompañantes terapéuticos que quieren
            ordenar su práctica, sostener el encuadre, intervenir en la vida
            cotidiana, registrar cada encuentro y coordinar mejor con el equipo
            interdisciplinario.
          </p>

          {/* CTA Button under mockup */}
          <button onClick={scrollToPricing} className="bg-amber-400 hover:bg-amber-300 text-teal-900 font-bold py-4 px-8 rounded-lg text-base md:text-lg transition-colors shadow-xl" data-id="element-17">
            SÍ, QUIERO EL KIT AHORA
          </button>
        </div>
      </div>

      {/* 8 Stages System - Compact */}
      <div className="py-8 px-4" data-id="element-18">
        <div className="max-w-4xl mx-auto" data-id="element-19">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-6" data-id="element-20">
            Sistema AT Profesional™ en 8 etapas
          </h2>
          <div className="grid grid-cols-2 gap-3" data-id="element-21">
            {[{
            num: '01',
            title: 'Primer encuentro con el acompañado',
            desc: 'Protocolo para el primer contacto con el acompañado y su familia.'
          }, {
            num: '02',
            title: 'Lectura del proyecto terapéutico',
            desc: 'Sistema para interpretar y llevar a la práctica las indicaciones del equipo.'
          }, {
            num: '03',
            title: 'Estructuración del dispositivo AT',
            desc: 'Cómo organizar los encuentros, definir objetivos y establecer el encuadre.'
          }, {
            num: '04',
            title: 'Intervención en la vida cotidiana',
            desc: 'Protocolo para acompañar en trayectos singulares sin invadir.'
          }, {
            num: '05',
            title: 'Manejo de crisis y situaciones de riesgo',
            desc: 'Sistema de intervención ante crisis y descompensaciones.'
          }, {
            num: '06',
            title: 'Registro e informe mensual',
            desc: 'Protocolo para registrar cada encuentro y redactar informes profesionales.'
          }, {
            num: '07',
            title: 'Coordinación con el equipo interdisciplinario',
            desc: 'Sistema para articular tu trabajo con otros profesionales.'
          }, {
            num: '08',
            title: 'Cierre del dispositivo',
            desc: 'Protocolo para cerrar el acompañamiento con criterio profesional.'
          }].map(stage => <div key={stage.num} className="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow" data-id="element-22">
                <div className="flex items-start gap-3" data-id="element-23">
                  <span className="text-2xl font-bold text-teal-600" data-id="element-24">
                    {stage.num}
                  </span>
                  <div data-id="element-25">
                    <h3 className="font-bold text-sm text-gray-900 mb-1" data-id="element-26">
                      {stage.title}
                    </h3>
                    <p className="text-xs text-gray-600" data-id="element-27">{stage.desc}</p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>

      {/* Bonuses Section - Compact with Icons */}
      <div className="bg-amber-50 py-8 px-4" data-id="element-28">
        <div className="max-w-4xl mx-auto" data-id="element-29">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-2" data-id="element-30">
            BONUS PROFESIONALES INCLUIDOS
          </h2>
          <p className="text-center text-teal-700 font-semibold mb-6" data-id="element-31">
            ¡GRATIS POR EL DÍA DE HOY!
          </p>

          <div className="grid md:grid-cols-3 gap-4" data-id="element-32">
            <div className="bg-white rounded-lg p-4 shadow-sm" data-id="element-33">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-34">
                <FileTextIcon className="w-8 h-8 text-teal-700" data-id="element-35" />
              </div>
              <h3 className="font-bold text-sm text-center mb-2" data-id="element-36">
                BONUS #1 — Pack de Planillas AT
              </h3>
              <p className="text-xs text-gray-600 text-center mb-2" data-id="element-37">
                Pack descargable de planillas profesionales para documentar tu
                trabajo.
              </p>
              <ul className="text-xs text-gray-600 space-y-1" data-id="element-38">
                <li data-id="element-39">✓ Informe Mensual AT</li>
                <li data-id="element-40">✓ Registro por Encuentro AT</li>
                <li data-id="element-41">✓ Seguimiento de Objetivos</li>
              </ul>
            </div>

            <div className="bg-white rounded-lg p-4 shadow-sm" data-id="element-42">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-43">
                <ClipboardListIcon className="w-8 h-8 text-teal-700" data-id="element-44" />
              </div>
              <h3 className="font-bold text-sm text-center mb-2" data-id="element-45">
                BONUS #2 — Banco de Actividades
              </h3>
              <p className="text-xs text-gray-600 text-center mb-2" data-id="element-46">
                Actividades concretas organizadas por objetivo terapéutico.
              </p>
              <ul className="text-xs text-gray-600 space-y-1" data-id="element-47">
                <li data-id="element-48">✓ Promover autonomía</li>
                <li data-id="element-49">✓ Fortalecer lazo social</li>
                <li data-id="element-50">✓ Organización del tiempo</li>
              </ul>
            </div>

            <div className="bg-white rounded-lg p-4 shadow-sm" data-id="element-51">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-52">
                <ShieldCheckIcon className="w-8 h-8 text-teal-700" data-id="element-53" />
              </div>
              <h3 className="font-bold text-sm text-center mb-2" data-id="element-54">
                BONUS #3 — Protocolo de Límites
              </h3>
              <p className="text-xs text-gray-600 text-center mb-2" data-id="element-55">
                Guía para establecer límites profesionales sin perder calidez.
              </p>
              <ul className="text-xs text-gray-600 space-y-1" data-id="element-56">
                <li data-id="element-57">✓ Encuadre del rol AT</li>
                <li data-id="element-58">✓ Límites con familia</li>
                <li data-id="element-59">✓ Autocuidado del AT</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Pricing Section - matches hero teal palette, countdown stays red */}
      <div id="pricing-section" className="min-h-screen flex items-center justify-center bg-gradient-to-br from-teal-800 via-teal-700 to-emerald-900 py-6 px-4" data-id="element-60">
        <div className="max-w-2xl mx-auto w-full" data-id="element-61">
          {/* Countdown Banner - stays red for urgency */}
          <div className="bg-red-600 text-white rounded-lg px-3 py-2 mb-4 text-center shadow-lg ring-2 ring-red-400/40" data-id="element-62">
            <p className="text-xs font-semibold mb-1 uppercase tracking-wide" data-id="element-63">
              ⏰ Oferta válida solo por hoy — Termina en:
            </p>
            <div className="flex justify-center gap-2 font-mono text-xl md:text-2xl font-bold" data-id="element-64">
              <div className="bg-red-800 rounded px-2 py-1 min-w-[2.5rem]" data-id="element-65">
                {String(timeLeft.hours).padStart(2, '0')}
                <span className="block text-[9px] font-normal" data-id="element-66">HRS</span>
              </div>
              <div className="bg-red-800 rounded px-2 py-1 min-w-[2.5rem]" data-id="element-67">
                {String(timeLeft.minutes).padStart(2, '0')}
                <span className="block text-[9px] font-normal" data-id="element-68">MIN</span>
              </div>
              <div className="bg-red-800 rounded px-2 py-1 min-w-[2.5rem]" data-id="element-69">
                {String(timeLeft.seconds).padStart(2, '0')}
                <span className="block text-[9px] font-normal" data-id="element-70">SEG</span>
              </div>
            </div>
          </div>

          <h2 className="text-xl md:text-2xl font-bold text-center text-white mb-1" data-id="element-71">
            ESTRUCTURÁ TU ACOMPAÑAMIENTO TERAPÉUTICO
          </h2>
          <p className="text-center text-teal-100 text-sm mb-4" data-id="element-72">
            Un solo pago. Tuyo para siempre.
          </p>

          <div className="grid grid-cols-2 gap-3 mb-4" data-id="element-73">
            {/* Regular Price Option */}
            <div onClick={() => setSelectedPrice('regular')} className={`border-2 rounded-lg p-3 cursor-pointer transition-all ${selectedPrice === 'regular' ? 'border-amber-300 bg-teal-900/40' : 'border-teal-600/50 bg-teal-900/20'}`} data-id="element-74">
              <div className="text-center" data-id="element-75">
                <p className="text-xs text-teal-100" data-id="element-76">Precio Regular</p>
                <p className="text-2xl font-bold text-teal-300/60 line-through" data-id="element-77">
                  $49.990
                </p>
                <p className="text-[10px] text-teal-200" data-id="element-78">ARS</p>
              </div>
            </div>

            {/* Discounted Price Option */}
            <div onClick={() => setSelectedPrice('discounted')} className={`border-2 rounded-lg p-3 cursor-pointer transition-all relative ${selectedPrice === 'discounted' ? 'border-amber-300 bg-amber-400/10' : 'border-teal-600/50 bg-teal-900/20'}`} data-id="element-79">
              <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 bg-red-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full whitespace-nowrap" data-id="element-80">
                60% OFF HOY
              </div>
              <div className="text-center" data-id="element-81">
                <p className="text-xs text-teal-100" data-id="element-82">Oferta Especial</p>
                <p className="text-2xl md:text-3xl font-bold text-amber-300" data-id="element-83">
                  $19.990
                </p>
                <p className="text-[10px] text-teal-200" data-id="element-84">ARS</p>
              </div>
            </div>
          </div>

          {/* What's Included - compact */}
          <div className="bg-white/10 backdrop-blur-sm border border-teal-500/30 rounded-lg p-3 mb-4" data-id="element-85">
            <h3 className="font-bold text-center text-sm mb-2 text-amber-300" data-id="element-86">
              Incluye:
            </h3>
            <div className="grid grid-cols-2 gap-x-3 gap-y-1 text-xs" data-id="element-87">
              <div className="flex items-start gap-1.5" data-id="element-88">
                <CheckCircleIcon className="w-3.5 h-3.5 text-amber-300 flex-shrink-0 mt-0.5" data-id="element-89" />
                <span className="text-teal-50" data-id="element-90">
                  KIT Acompañante Terapéutico
                </span>
              </div>
              <div className="flex items-start gap-1.5" data-id="element-91">
                <CheckCircleIcon className="w-3.5 h-3.5 text-amber-300 flex-shrink-0 mt-0.5" data-id="element-92" />
                <span className="text-teal-50" data-id="element-93">Sistema AT en 8 etapas</span>
              </div>
              <div className="flex items-start gap-1.5" data-id="element-94">
                <CheckCircleIcon className="w-3.5 h-3.5 text-amber-300 flex-shrink-0 mt-0.5" data-id="element-95" />
                <span className="text-teal-50" data-id="element-96">BONUS: Planillas AT</span>
              </div>
              <div className="flex items-start gap-1.5" data-id="element-97">
                <CheckCircleIcon className="w-3.5 h-3.5 text-amber-300 flex-shrink-0 mt-0.5" data-id="element-98" />
                <span className="text-teal-50" data-id="element-99">BONUS: Banco Actividades</span>
              </div>
              <div className="flex items-start gap-1.5" data-id="element-100">
                <CheckCircleIcon className="w-3.5 h-3.5 text-amber-300 flex-shrink-0 mt-0.5" data-id="element-101" />
                <span className="text-teal-50" data-id="element-102">BONUS: Protocolo Límites</span>
              </div>
              <div className="flex items-start gap-1.5" data-id="element-103">
                <CheckCircleIcon className="w-3.5 h-3.5 text-amber-300 flex-shrink-0 mt-0.5" data-id="element-104" />
                <span className="text-teal-50" data-id="element-105">Acceso inmediato</span>
              </div>
              <div className="flex items-start gap-1.5" data-id="element-106">
                <CheckCircleIcon className="w-3.5 h-3.5 text-amber-300 flex-shrink-0 mt-0.5" data-id="element-107" />
                <span className="text-teal-50" data-id="element-108">Pago único</span>
              </div>
              <div className="flex items-start gap-1.5" data-id="element-109">
                <CheckCircleIcon className="w-3.5 h-3.5 text-amber-300 flex-shrink-0 mt-0.5" data-id="element-110" />
                <span className="text-teal-50" data-id="element-111">Material descargable</span>
              </div>
            </div>
          </div>

          {/* CTA Button */}
          <button onClick={handlePurchase} className="w-full bg-amber-400 hover:bg-amber-300 text-teal-900 font-bold py-3.5 px-6 rounded-lg text-base md:text-lg transition-colors shadow-xl" data-id="element-112">
            SÍ, QUIERO EL KIT AHORA
          </button>
          <p className="text-center text-xs text-teal-100 mt-2" data-id="element-113">
            Pago único · Acceso inmediato · Garantía 7 días
          </p>
        </div>
      </div>

      {/* Testimonials - more visually attractive */}
      <div className="py-12 px-4 bg-gradient-to-b from-amber-50 to-orange-50" data-id="element-114">
        <div className="max-w-5xl mx-auto" data-id="element-115">
          <p className="text-center text-xs font-bold text-orange-600 uppercase tracking-widest mb-2" data-id="element-116">
            ★ Testimonios reales ★
          </p>
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-2 text-gray-900" data-id="element-117">
            Lo que dicen los profesionales
          </h2>
          <p className="text-center text-gray-600 text-sm mb-8" data-id="element-118">
            Acompañantes terapéuticos que ya están aplicando el sistema
          </p>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-119">
            {[{
            name: 'Dra. Sofía Ramírez',
            role: 'Acompañante Terapéutica',
            text: 'Este kit transformó mi práctica. Ahora tengo estructura clara para cada etapa del acompañamiento.',
            color: 'from-teal-500 to-emerald-600'
          }, {
            name: 'Lic. Martín Fernández',
            role: 'AT con 5 años de experiencia',
            text: 'Las plantillas de registro me ahorraron horas de trabajo. Muy profesional y completo.',
            color: 'from-amber-500 to-orange-600'
          }, {
            name: 'Carolina Vega',
            role: 'Acompañante Terapéutica',
            text: 'El protocolo de límites fue exactamente lo que necesitaba. Me ayudó a sostener el encuadre sin perder calidez.',
            color: 'from-rose-500 to-pink-600'
          }, {
            name: 'Dr. Pablo Moreno',
            role: 'Coordinador de equipo AT',
            text: 'Recomiendo este kit a todos los AT de mi equipo. La coordinación mejoró notablemente.',
            color: 'from-indigo-500 to-purple-600'
          }, {
            name: 'Lic. Valeria Castro',
            role: 'AT especializada en adultos mayores',
            text: 'El banco de actividades es oro puro. Siempre tengo propuestas concretas para cada encuentro.',
            color: 'from-sky-500 to-blue-600'
          }].map((testimonial, idx) => {
            const initials = testimonial.name.split(' ').filter(w => !w.endsWith('.')).slice(0, 2).map(w => w[0]).join('');
            return <div key={idx} className="bg-white rounded-2xl p-5 shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300 relative border border-orange-100" data-id="element-120">
                  {/* Decorative quote mark */}
                  <div className="absolute -top-3 -left-2 text-5xl font-serif text-orange-300 leading-none select-none" data-id="element-121">
                    "
                  </div>
                  {/* Stars */}
                  <div className="flex gap-0.5 mb-3 relative" data-id="element-122">
                    {[...Array(5)].map((_, i) => <svg key={i} className="w-4 h-4 text-amber-400 fill-current" viewBox="0 0 20 20" data-id="element-123">
                        <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" data-id="element-124" />
                      </svg>)}
                  </div>
                  <p className="text-sm text-gray-700 mb-4 leading-relaxed italic relative" data-id="element-125">
                    {testimonial.text}
                  </p>
                  <div className="flex items-center gap-3 pt-3 border-t border-gray-100" data-id="element-126">
                    <div className={`w-11 h-11 rounded-full bg-gradient-to-br ${testimonial.color} flex items-center justify-center text-white font-bold text-sm flex-shrink-0 shadow-md`} data-id="element-127">
                      {initials}
                    </div>
                    <div className="flex-1 min-w-0" data-id="element-128">
                      <p className="font-bold text-sm text-gray-900 truncate" data-id="element-129">
                        {testimonial.name}
                      </p>
                      <p className="text-xs text-gray-500 truncate" data-id="element-130">
                        {testimonial.role}
                      </p>
                    </div>
                    <CheckCircleIcon className="w-4 h-4 text-teal-500 flex-shrink-0" data-id="element-131" />
                  </div>
                </div>;
          })}
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="bg-gray-900 text-gray-400 py-6 px-4 text-center text-xs" data-id="element-132">
        <p className="mb-2" data-id="element-133">
          © 2026 KIT Acompañante Terapéutico. Todos los derechos reservados.
        </p>
        <p className="max-w-3xl mx-auto" data-id="element-134">
          Este material es una herramienta educativa y profesional para
          acompañantes terapéuticos. No reemplaza la formación específica, la
          supervisión profesional, las indicaciones del equipo
          interdisciplinario ni los protocolos institucionales o legales
          correspondientes.
        </p>
        <p className="mt-3 text-gray-500" data-id="element-135">
          Este sitio no es parte del sitio web de Facebook o Meta Inc. Además,
          este sitio NO está respaldado por Facebook de ninguna manera.
        </p>
      </div>
    </div>;
}